export default {
    get: {

    },
    post: {
        // 分页查询必采关系
        relationPageQuery: "/mall-smartlist/api/dmall/bc/bcRelationPageQuery",
        // 根据ssuId分页查询绑定门店
        relationStorePageQuery: "/mall-smartlist/api/dmall/bc/bcRelationStorePageQuery",
        // 查询添加必采关系的候选商品
        queryCandidateGoodsItems: "/mall-smartlist/api/dmall/bc/bcQueryCandidateGoodsItems",
        // 查询添加必采关系的候选门店
        queryCandidateStoreItems: "/mall-smartlist/api/dmall/bc/bcQueryCandidateStoreItems",
        // 创建必采关联关系
        createBCRelations: "/mall-smartlist/api/dmall/bc/bcCreateBCRelations",
        // 批量删除必采关系
        deleteBCRelations: "/mall-smartlist/api/dmall/bc/bcDeleteBCRelations",
        // 为已存在的必采关系中绑定门店
        bindStores2Relation: "/mall-smartlist/api/dmall/bc/bcBindStores2Relation",
        // 批量删除必采关系中绑定的门店
        deleteRelationBindStores: "/mall-smartlist/api/dmall/bc/bcDeleteRelationBindStores",
        // 更新必采关系状态
        updateRelationStatus: "/mall-smartlist/api/dmall/bc/bcUpdateRelationStatus",
        // 修改下单后规则失效
        bcUpdateInvalidStatus: "/mall-smartlist/api/dmall/bc/bcUpdateInvalidStatus",
    }
}
